export default __webpack_public_path__ + "static/FooterMenuContactMenuSocialsCopyrightBottomMenu-650102509bb8882e24a86dd6a8831ec7.jpg";